const MARKDOWN_HELP = `
# Range Mapping (값 범위 매핑)

Range Mapping 기능을 사용하면 **입력 값이 특정 범위에 속할 경우 해당하는 출력 값을 반환**할 수 있습니다.  
이 기능은 **숫자 범위를 기준으로 데이터를 변환하거나 분류**하는 데 유용합니다.

## 🛠 사용 방법

1. **입력값**: 숫자 값 (예: 점수, 가격, 온도 등)
2. **범위 매핑**: 특정 범위 내의 값에 대응하는 결과 값을 설정
3. **출력값**: 입력값이 속한 범위의 매핑 결과를 반환

---

## 📌 예제 1: 점수에 따른 등급 부여
### 매핑 설정:
| 입력 범위 | 출력 값 |
|-----------|---------|
| 0 - 59    | "F"     |
| 60 - 69   | "D"     |
| 70 - 79   | "C"     |
| 80 - 89   | "B"     |
| 90 - 100  | "A"     |

### 입력값: 
\`\`\`json
75
\`\`\`

### 결과:
\`\`\`json
"C"
\`\`\`

---

## 📌 예제 2: 온도에 따른 상태 분류
### 매핑 설정:
| 입력 범위  | 출력 값  |
|------------|---------|
| -∞ - 0°C   | "Cold"  |
| 1°C - 20°C | "Cool"  |
| 21°C - 30°C | "Warm"  |
| 31°C - ∞   | "Hot"   |

### 입력값: 
\`\`\`json
25
\`\`\`

### 결과:
\`\`\`json
"Warm"
\`\`\`

---

## 📌 예제 3: 급여 구간에 따른 세금율 적용
### 매핑 설정:
| 급여 범위         | 세율 (%) |
|------------------|---------|
| 0 - 20,000      | 5%      |
| 20,001 - 50,000 | 10%     |
| 50,001 - 100,000| 20%     |
| 100,001 이상    | 30%     |

### 입력값: 
\`\`\`json
45000
\`\`\`

### 결과:
\`\`\`json
"10%"
\`\`\`

---

## ⚙ 설정 방법
1. **범위 기준**을 설정합니다.  
   - 예: \`0 - 59 → "F"\`, \`60 - 69 → "D"\`  
2. **입력값이 해당 범위 내에 있는지 검사**합니다.  
3. **일치하는 범위의 출력 값을 반환**합니다.  

---

## 🔍 주요 특징
- **숫자 범위 기반 데이터 변환** (예: 등급 부여, 상태 분류, 세율 적용 등)
- **범위는 연속적이며 겹치지 않도록 설정**해야 합니다.
- **오름차순으로 설정**해야 정확한 매핑이 가능합니다.

💡 **Range Mapping을 사용하여 데이터를 쉽고 직관적으로 변환하세요!**
`

export const RangeMapping = {
  name: 'range-mapping',
  label: 'Range Mapping',
  specifications: [
    {
      type: 'range',
      name: 'ranges',
      label: 'Value Ranges'
    }
  ],
  help: MARKDOWN_HELP
}
